import { PopoverProps } from '@wix/design-system'

export const selectPopoverProps: PopoverProps = {
  animate: true,
  timeout: 1,
  moveBy: { y: 6 },
}
